const GIF_QUALITY = "gifQuality";

const GIF_SOUND = "gifSound";

const TEMPORARY_ACCESS_TOKEN = "temporary_access_token";

const DISABLE_ADS = "disable_ads";

const AUTH_DATA = "auth_data";

const LS_KEY = "cookie_notice";

const EXPERIMENTS = "experiments";

const MIGRATE_IMGUR_POPUP = "migrate_imgur_popup";

const BOOSTED_GIFS = "boosted_gifs";

const DISMISS_SCROLL_MORE = "dismiss_scroll_more";

const ANONYMOUS_LIKED_TOAST = "anonymous_liked_toast";

const load = (key: string) => () => {
  const storage = getLocalStorage();

  if (!storage) {
    return null;
  }

  const serializedValue = storage.getItem(key);

  if (serializedValue === null) {
    return serializedValue;
  }

  try {
    return JSON.parse(serializedValue);
  } catch (e) {
    return serializedValue;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const set = (key: string) => (value?: any) => {
  if (typeof value !== "undefined" && value !== null) {
    const storage = getLocalStorage();

    if (storage) {
      const serializedValue = ["object", "array"].includes(typeof value)
        ? JSON.stringify(value)
        : value;

      storage.setItem(key, serializedValue);
    }
  } else {
    remove(key)();
  }
};

const remove = (key: string) => () => {
  const storage = getLocalStorage();

  if (storage) {
    storage.removeItem(key);
  }
};

const getLocalStorage = () => {
  try {
    return localStorage;
  } catch (e) {
    const { name, message } = e as Error;
    // eslint-disable-next-line
    console.log(name, message);
  }

  return null;
};

export const loadTemporaryAccessToken = load(TEMPORARY_ACCESS_TOKEN);

export const loadDisableAds = load(DISABLE_ADS);

export const loadAuth = load(AUTH_DATA);

export const loadGIFQuality = load(GIF_QUALITY);

export const loadGIFSound = load(GIF_SOUND);

export const loadCookieNotice = load(LS_KEY);

export const loadExperiments = load(EXPERIMENTS);

export const loadMigrateImgurPopup = load(MIGRATE_IMGUR_POPUP);

export const loadBoostedGifs = load(BOOSTED_GIFS);

export const loadDismissScrollMore = load(DISMISS_SCROLL_MORE);

export const loadAnonymousLikedToast = load(ANONYMOUS_LIKED_TOAST);

export const setGIFSound = (value: string) => set(GIF_SOUND)(value);

export const setGIFQuality = (value: string) => set(GIF_QUALITY)(value);

export const setCookieNotice = (value: string) => set(LS_KEY)(value);

export const setTemporaryAccessToken = set(TEMPORARY_ACCESS_TOKEN);

export const setAuth = set(AUTH_DATA);

export const setExperiments = set(EXPERIMENTS);

export const setMigrateImgurPopup = set(MIGRATE_IMGUR_POPUP);

export const setBoostedGifs = set(BOOSTED_GIFS);

export const setDismissScrollMore = set(DISMISS_SCROLL_MORE);

export const setAnonymousLikedToast = set(ANONYMOUS_LIKED_TOAST);
